import type { EventSink } from '../events'
import { NO_TICK } from '../world'
import type { World } from '../world'

/**
 * Stun plumbing. `hit()` (T1.3) is the real damage path; this applies the stun itself as a
 * tumble (D-045): input is ignored until `stunnedUntil`, the runner is kicked up by
 * `tumblePopVelocity` (never slowing a faster rise) and drifts on at `tumbleSpeedPct`, a pending
 * jump press is dropped, and post-stun invulnerability follows.
 */
export function stunPlayer(world: World, i: number, ticks: number, events: EventSink): void {
  const p = world.players[i]!
  const { cfg, tick } = world
  p.stunnedUntil = tick + ticks
  p.invulnUntil = Math.max(p.invulnUntil, p.stunnedUntil + cfg.postStunInvulnTicks)
  p.jumpBufferedUntil = NO_TICK
  p.jumpHeldTicks = 0
  if (cfg.tumblePopVelocityPxPerTick > 0) {
    p.vy = Math.min(p.vy, -cfg.tumblePopVelocityPxPerTick)
    p.grounded = false
    p.coyoteUntil = NO_TICK
  }
  events.push({ type: 'stunStart', tick, player: i, untilTick: p.stunnedUntil })
}

/** Emit `stunEnd` on the tick a stun expires. */
export function updateStun(world: World, i: number, events: EventSink): void {
  const p = world.players[i]!
  if (p.stunnedUntil > 0 && p.stunnedUntil === world.tick) {
    events.push({ type: 'stunEnd', tick: world.tick, player: i })
  }
}
